// extracted by mini-css-extract-plugin
export default {"mainContainerLayout":"DetailsPage_mainContainerLayout__JYBFS"};